<div
  [ngStyle]="{ 'margin-top': isLibrary ? '4vh' : '0vh' }"
  id="guidelines_input_screen_container"
>
  <div>
    <div class="guidelines_header">
      <div class="user_header">
        <em
          class="bi bi-person"
          style="font-size: 1.3rem; margin-right: 0.6vw"
        ></em>
        User
      </div>
      <div class="view-edit-text">
        <div>Edit Mode</div>
        <div>/</div>
        <div>{{ this.guideline_version_name }}</div>
      </div>
      <div class="content">
        <div class="category">
          <div *ngFor="let category of categories">
            <div
              style="
                padding: 0.5vw;
                border-radius: 0.2vw;
                font-weight: 600;
                font-size: 0.95vw;
                cursor: pointer;
              "
              [ngClass]="{ selected: selectedCategory == category }"
              (click)="changeCategory(category)"
            >
              {{ category.toUpperCase() }}
              <!-- <img
                style="margin-left: 0.5vw; height: 1.5vh"
                [src]="
                  selectedCategory == category
                    ? '../../assets/lock_white.png'
                    : '../../assets/lock.png'
                "
              /> -->
            </div>
          </div>
        </div>
      </div>
      <!-- <div
        [ngClass]="{ selected: selectedCategory == 'npds' }"
        (click)="changeCategory('npds')"
        class="npd_edit"
      >
        <em
          *ngIf="!isLibrary"
          class="bi bi-pencil"
          style="font-size: 1rem; cursor: pointer; margin-right: 0.6vw"
        ></em>
        NPD
      </div> -->
    </div>
    <!-- <div class="note">
      <div
          *ngIf="
            guidelines_input &&
            guidelines_input.methodology &&
            guidelines_input.methodology[
              selectedCategory == 'npds' ? 'NPD' : selectedCategory
            ]
          "
        >
          {{
            guidelines_input.methodology[
              selectedCategory == "npds" ? "NPD" : selectedCategory
            ].heading
          }}
        </div>
    </div> -->
    <!-- <div
      class="flavor_pack_size_dropdown_container"
      style="
        display: flex;
        margin-left: 2vw;
        margin-top: 2vh;
        gap: 1vw;
        align-items: baseline;
      "
    >
      <mat-label class="label-heading">Flavor:</mat-label>
      <mat-form-field class="filter-dropdown">
        <mat-select
          multiple
          [(ngModel)]="selectedFlavour"
          (selectionChange)="onFlavorAndPackSizeChange()"
          class="filter-select"
        >
          <mat-option (click)="AllFlavorsToggle()" value="All"
            ><mat-checkbox [checked]="allFlavoursSelected"
              >All</mat-checkbox
            ></mat-option
          >
          <mat-option [value]="f" *ngFor="let f of flavour"
            ><mat-checkbox [checked]="selectedFlavour.includes(f)">{{
              f
            }}</mat-checkbox></mat-option
          >
          >
        </mat-select>
      </mat-form-field>
      <mat-label class="label-heading">Size:</mat-label>
      <mat-form-field class="filter-dropdown">
        <mat-select
          multiple
          [(ngModel)]="selectedPackSize"
          (selectionChange)="onFlavorAndPackSizeChange()"
          class="filter-select"
        >
          <mat-option (click)="allPackSizesToggle()" value="All">
            <mat-checkbox [checked]="allPackSizesSelected"
              >All</mat-checkbox
            ></mat-option
          >
          <mat-option [value]="s" *ngFor="let s of pack_size"
            ><mat-checkbox [checked]="selectedPackSize.includes(s)">{{
              s
            }}</mat-checkbox></mat-option
          >
        </mat-select>
      </mat-form-field>
    </div> -->
    <div class="channel_cooler_unit_value">
      {{ cooler }}, {{ channel }}, {{ unit }}
    </div>
    <div style="display: flex; gap: 10%; margin: 1.5vw">
      <div style="width: 100%; height: 47vh; display: flex; gap: 5vw">
        <div
          style="width: 45%; overflow: auto"
          *ngFor="let cooler of no_of_coolers; let j = index"
        >
          <table
            *ngIf="dataSources_forCooler[j].data.length > 0"
            class="sku-table"
            mat-table
            #mytable
            [dataSource]="dataSources_forCooler[j]"
          >
            <ng-container matColumnDef="no">
              <th
                style="
                  padding-left: 10px;
                  width: 60px;
                  width: 6%;
                  font-size: 0.95vw;
                  font-weight: 600;
                "
                mat-header-cell
                *matHeaderCellDef
              >
                SKU
              </th>
              <td
                mat-cell
                style="padding-bottom: 1.5vh"
                *matCellDef="let data; let i = index"
              >
                {{ i + 1 }}.
              </td>
            </ng-container>
            <!-- <ng-container matColumnDef="sku_img">
            <th
              style="padding-left: 10px; width: 60px; width: 10%"
              mat-header-cell
              *matHeaderCellDef
            ></th>
            <td mat-cell style="padding-bottom: 1.5vh" *matCellDef="let data">
              <img
                *ngIf="data.sku_image_uri"
                style="height: 10vh; margin-bottom: 1.5vh"
                [src]="data.sku_image_uri + sas"
              />
            </td>
          </ng-container> -->
            <ng-container matColumnDef="dropdown">
              <th
                style="padding-left: 10px; width: 60px"
                mat-header-cell
                *matHeaderCellDef
              >
                {{ cooler }}
              </th>
              <td
                mat-cell
                style="padding-bottom: 1.5vh"
                *matCellDef="let data; let i = index"
              >
                <mat-form-field *ngIf="selectedCategory !== 'NPD'">
                  <mat-select [value]="data.sku_name">
                    <mat-option [value]="data.sku_name">
                      {{ data.sku_name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field *ngIf="selectedCategory == 'NPD'">
                  <mat-select [value]="data.product_name">
                    <mat-option
                      *ngFor="let npd of npds_data_options"
                      [value]="npd.product_name"
                      (click)="selectNpds(npd, i)"
                    >
                      {{ npd.product_name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </td>
            </ng-container>
            <ng-container
              *ngIf="selectedCategory == 'Stills'"
              matColumnDef="sku_min_face"
            >
              <th
                style="
                  padding-left: 10px;
                  width: 60px;
                  width: 8%;
                  font-size: 0.95vw;
                  font-weight: 600;
                "
                mat-header-cell
                *matHeaderCellDef
              >
                Min Facings
              </th>
              <td
                style="padding-bottom: 1.5vh"
                mat-cell
                *matCellDef="let data; let i = index"
              >
                <div class="increment_decrement_container">
                  <button
                    (click)="minDecrementFacings(cooler, data, i)"
                    class="minus"
                  >
                    -
                  </button>
                  <input
                    style="width: 3vw; height: 4vh; font-size: 0.9vw"
                    [value]="data.min_facings"
                    type="text"
                    class="input-number npd_counter_value"
                  />
                  <button
                    (click)="minIncrementFacings(cooler, data, i)"
                    class="plus"
                  >
                    +
                  </button>
                </div>
              </td>
            </ng-container>
            <ng-container
              *ngIf="selectedCategory == 'Stills'"
              matColumnDef="sku_max_face"
            >
              <th
                style="
                  padding-left: 10px;
                  width: 60px;
                  width: 8%;
                  font-size: 0.95vw;
                  font-weight: 600;
                "
                mat-header-cell
                *matHeaderCellDef
              >
                Max Facings
              </th>
              <td
                style="padding-bottom: 1.5vh"
                mat-cell
                *matCellDef="let data; let i = index"
              >
                <div class="increment_decrement_container">
                  <button
                    (click)="maxDecrementFacings(cooler, data, i)"
                    class="minus"
                  >
                    -
                  </button>
                  <input
                    style="width: 3vw; height: 4vh; font-size: 0.9vw"
                    [value]="data.max_facings"
                    type="text"
                    class="input-number npd_counter_value"
                  />
                  <button
                    (click)="maxIncrementFacings(cooler, data, i)"
                    class="plus"
                  >
                    +
                  </button>
                </div>
              </td>
            </ng-container>
            <ng-container
              *ngIf="selectedCategory !== 'Stills'"
              matColumnDef="sku_facings"
            >
              <th
                style="
                  padding-left: 10px;
                  width: 60px;
                  width: 8%;
                  font-size: 0.95vw;
                  font-weight: 600;
                "
                mat-header-cell
                *matHeaderCellDef
              >
                Facings
              </th>
              <td
                style="padding-bottom: 1.5vh"
                mat-cell
                *matCellDef="let data; let i = index"
              >
                <div class="increment_decrement_container">
                  <button
                    (click)="decrementFacings(cooler, data, i)"
                    class="minus"
                  >
                    -
                  </button>
                  <input
                    style="width: 3vw; height: 4vh; font-size: 0.9vw"
                    [value]="data.facings ? data.facings : data.min_facings"
                    type="text"
                    class="input-number npd_counter_value"
                  />
                  <button
                    (click)="incrementFacings(cooler, data, i)"
                    class="plus"
                  >
                    +
                  </button>
                </div>
              </td>
            </ng-container>
            <tr
              mat-header-row
              *matHeaderRowDef="
                selectedCategory == 'Stills'
                  ? columns
                  : columns_when_not_stills;
                sticky: true
              "
            ></tr>
            <tr
              mat-row
              *matRowDef="
                let row;
                columns: selectedCategory == 'Stills'
                  ? columns
                  : columns_when_not_stills
              "
            ></tr>
          </table>
        </div>
      </div>
      <!-- <div class="methodology-section">
        <div style="width: 100%">
          <div class="heading">Methodology</div>
          <div class="methodology_box">
            <div>
              <img src="../../assets/idea_icon.png" />
            </div>
            <div
                *ngIf="
                  guidelines_input.methodology &&
                  guidelines_input.methodology[
                    selectedCategory == 'npds' ? 'NPD' : selectedCategory
                  ]
                "
              >
                <div
                  [innerHTML]="
                    guidelines_input.methodology[
                      selectedCategory == 'npds' ? 'NPD' : selectedCategory
                    ].description
                  "
                ></div>
              </div>
          </div>
        </div> 
      </div> -->
    </div>
    <div
      *ngIf="selectedCategory !== 'NPD'"
      style="margin-left: 2vw; color: #e61a27; font-size: 0.9vw"
    >
      *Please select a number between 0 and 6
    </div>
    <div
      *ngIf="selectedCategory === 'NPD'"
      style="margin-left: 2vw; color: black; font-size: 0.9vw"
    >
      <ng-container *ngFor="let segment of renderHtml('*' + npd_description)">
        <b *ngIf="segment.isBold">{{ segment.text }}</b>
        <span *ngIf="!segment.isBold">{{ segment.text }}</span>
      </ng-container>
    </div>
  </div>
</div>
